import { Global, Jobs, JobsCategory } from '@sourceflow-uk/sourceflow-sdk';
import "@sourceflow-uk/job-search/dist/bundle.css";
import SeoHead from '../../components/SeoHead';
import Newsletter from '../../components/Newsletter';
import JobDetails from '../../components/JobDetails';
import MainBanner from '../../components/MainBanner';
import GoogleJobSchema from "../../components/GoogleJsonData";
import ThemeBMultiColumnCTA from '../../components/ThemeBMultiColumnCTA';

export default function JobsPage({
  global,
  page,
  similar_jobs,
  job_type
}) {
  return (
    <>
      <SeoHead
        page_name={`${page.title} in ${page.location} | SRG`}
        description={`Apply for ${page.title} in ${page.location} with SRG, specialists in Life Sciences.`}
        canonical_link={`jobs/${page.url_slug}`}
      />
      <MainBanner
        global={global}
        pathPrefix={`job_page.main_banner`}
        customClass={``}
        content={``}
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
        imageALT2={`Overlay Main Banner`}
        displayImage1={false}
      />

      <JobDetails
        global={global}
        pathPrefix={`job_page.job_details`}
        customClass={`position-relative mb-5`}
        post={page}
        buttonTitle={`Back to previous page`}
        buttonLink={`/jobs/`}
        job={page}
        job_type={job_type}
        jobId={`${page.id}`}
        successPageUrl={`/jobs/thank-you-for-applying`}
        content={
          <>
            <h2>Apply to this Job</h2>
          </>
        }
        share_job_content={
          <p><strong>Share this Job</strong></p>
        }
        similar_jobs={similar_jobs}
      />
      {/* <Newsletter
        global={global}
        pathPrefix={`job_page.newsletter`}
        customClass={`py-5 grayGradientBg`}
        content={
          <>
            <h2>More Informations</h2>
          </>
        }
        content_2={
          <>
            <h2>Subscribe to our newsletter</h2>
            <p>up to date with Lorien</p>
          </>
        }
        formId={`e1da7ff6-feb2-4696-93be-b43ec16b6009`}
        successPageUrl={`/jobs/subscription-success/`}
        buttonTitle={`Insights`}
        buttonLink={`/blog/`}
        buttonTitle2={`Similar Roles`}
        buttonLink2={`/`}
      /> */}
      <ThemeBMultiColumnCTA
        limit={3}
        newTab={false}
        content={'<h2>Insights</h2><p>We believe in the power of science - that\'s why we stay at the forefront of the life sciences industry, keeping up to date with the latest research, innovations, and market trends to provide valuable insight and guidance to our clients and candidates.</p>'}
        filters=""
        className="py-4"
        pagePrefix="/blog/"
        left_content={'<h2>Read our insights</h2><p>We are always learning, adapting, and educating.</p>'}
        buttonLink_left="/blog"
        buttonTitle_left="See more"
      />
      <GoogleJobSchema
        job={page}
        job_type={job_type}
        job_currency={`GBP`}
        job_payment_type={`YEAR`}
        job_country={`United Kingdom`}
        site_name={`SRG`}
        site_domain_link={`https://www.srgtalent.com/`}
        site_google_logo_link={`https://www.srgtalent.com/site-assets/images/google-image.jpg`}
        site_domain_jobs_link={`https://www.srgtalent.com/jobs`}
      />
    </>
  )
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const page = (await Jobs()).getJsonItem(params.slug, 'url_slug');


  const currentjob = await Jobs();
  const internalcategory = currentjob.getItems().find(j => j.url_slug === params.slug);
  // Checks sector category
  const getIndexedValues = async function (categoryName) {
    const category = await JobsCategory(categoryName)
    return [category, category.items.reduce((previous, value) => ({ [value.id]: value, ...previous }), {})]
  }
  const jobTypeCategory = await getIndexedValues('Job Type');

  const jobTypeSectorIds = internalcategory.categories.find((cat) => cat.id === jobTypeCategory[0].id)?.values || []

  const jobType = jobTypeSectorIds.map((jobtype, index) => jobTypeCategory[1][jobtype.id] ? jobTypeCategory[1][jobtype.id].title?.en + `${jobTypeCategory.length > 1 ? `${index === jobTypeSectorIds.length - 1 ? "" : ", "}` : ""}` || null : null);

  // Get similar jobs
  const sectorCategory = await getIndexedValues("Sectors");

  const jobSectorIds =
    internalcategory.categories.find((cat) => cat.id === sectorCategory[0].id)
      ?.values || [];

  const targetSectorName = jobSectorIds[0]?.title;

  let similar_jobs;

  similar_jobs = (await Jobs())
    .getItems()
    .filter((post) =>
      post.url_slug !== page.url_slug &&
      post.categories
        ?.find((cat) => cat.title === "Sectors")
        ?.values?.some((value) => value.title.includes(targetSectorName))
    )
    .filter(function (job) {
      return new Date(job?.expires_at) >= new Date();
    })
    .slice(0, 3);

  return {
    props: {
      global,
      page,
      similar_jobs,
      job_type: jobType,
    }
  };
}

export async function getStaticPaths() {
  const jobs = await Jobs();
  const jobsSlugs = jobs.filter(function (job) {
    return (
      job.categories
        // all not US jobs
        .find((cat) => cat.id === "b4b8be3c-ba95-4912-aa85-2cbc1264449d" && !cat.values.map((x) => x.id).includes("ef634a2a-8e52-45c1-ad8d-62ec0a93d19b"))
    );
  }).map('url_slug').getItems()

  const paths = jobsSlugs.map((jobSlug) => ({
    params: { slug: jobSlug },
  }))
  return { paths, fallback: false }
}
